import {http} from "@/api/HttpClient.ts";
import {Spell} from "@/spells/model/Spell.ts";
import {Character} from "@/characters/model/Character.ts";

export type ModalContentType = "NONE" | "SPELL" | "CHARACTER";

export type ModalPresentation =
    | {type: "NONE"; contentId?: null; spell?: never; character?: never; revision: number}
    | {type: "SPELL"; contentId: string; spell: Spell; character?: never; revision: number}
    | {type: "CHARACTER"; contentId: string; character: Character; spell?: never; revision: number};

export interface ModalPresentationUpdate {
    type: ModalContentType;
    contentId?: string;
}

export async function getCampaignModalPresentation(campaignId: string): Promise<ModalPresentation> {
    const response = await http.get<ModalPresentation>(`/campaigns/${campaignId}/modal-presentation`);
    return response.data;
}

export async function updateCampaignModalPresentation(
    campaignId: string,
    update: ModalPresentationUpdate,
): Promise<ModalPresentation> {
    const response = await http.put<ModalPresentation>(`/campaigns/${campaignId}/modal-presentation`, update);
    return response.data;
}
